import React, { useState } from 'react';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';
import { CalendarDays, X } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Calendar } from '@/components/ui/calendar';

export const DateField = ({ value, onChange, placeholder, testId }) => {
  const [open, setOpen] = useState(false);
  const date = value ? parse(value, 'yyyy-MM-dd', new Date()) : undefined;
  return (
    <div className="flex items-center gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" className="h-10 w-36 rounded-md border px-3 text-sm flex items-center gap-2 bg-white hover:border-orange-300" data-testid={testId}>
            <CalendarDays className="w-4 h-4 text-slate-400" />
            <span className={date ? 'text-slate-800' : 'text-slate-400'}>{date ? format(date, 'dd-MM-yyyy') : placeholder}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" locale={es} selected={date} onSelect={(d) => { onChange(d ? format(d, 'yyyy-MM-dd') : ''); setOpen(false); }} />
        </PopoverContent>
      </Popover>
      {value && (
        <button type="button" onClick={() => onChange('')} className="text-slate-400 hover:text-slate-600" data-testid={`${testId}-clear`}>
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
